<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item()['geschaeftsfall']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">
      @if (item()['bezeichnung'] | isDefinedNotEmpty) {
        {{item()['bezeichnung']}}
      }
      @if (item()['artbez1'] | isDefinedNotEmpty) {
        {{item()['artbez1']}}
      }
      @if (item()['artbez2'] | isDefinedNotEmpty) {
        {{item()['artbez2']}}
      }
      @if (item()['gfnr'] | isDefinedNotEmpty) {
        {{item()['gfnr']}}
      }
    </span>
  </div>
</div>
